import React from "react";
import "./icon-arrow-rigthAnimation.css";
export const IconArrowRightAnimation = () => {
  return (
    <div className="hackeye">
      <div className="arrowCta"></div>
    </div>
  );
};
